import { create } from 'zustand';
import { creditApi, ISubscription } from '../api';
import { toast } from 'react-toastify';

type CreditState = {
  isInactivePlan: boolean;
  isSecondsExhaustedModal: boolean;
  secondsExhaustedCallbackContinue: (() => void) | null;
  isChatAvailable: boolean;
  premiumVoicesAllowed: boolean;
  productName: string;
  isEmbedAvailable: boolean;
  seconds: number;
  isBasePlan: boolean;
  isNotEnoughSecondsModal: boolean;
};

type CreditActions = {
  updateCreditStore: (key: string, value: any) => void;
  toggleFeatureBlockModal: (open: boolean | typeof features[number]) => void;
  toggleInactivePlanModal: () => void;
  toggleBuyCreditsModal: () => void;
  toggleUpgradeModal: () => void;
  setIsSecondsExhaustedModal: (value: boolean) => void;
  setSecondsExhaustedCallbackContinue: (callback: (() => void) | null) => void;
  getSubscriptions: (key: string) => Promise<ISubscription[] | undefined>;
  currentSubscription: ISubscription | null;
  setNotEnoughSecondsModal: (value: boolean) => void;
};

export const features = [
  'express',
  'pro',
  'agents',
  'embed',
  'extraCredits',
  'api',
  'premiumVoices',
  'speech',
  'chatGpt',
  'createAvatar'
] as const;

export type CreditStore = CreditState & CreditActions;

export const creditStore = create<CreditStore>()((set, get) => ({
  toggleUpgradeModal: () => {},
  toggleBuyCreditsModal: () => {},
  toggleFeatureBlockModal: (open) => {},
  toggleInactivePlanModal: () => {},
  isSecondsExhaustedModal: false,
  secondsExhaustedCallbackContinue: null,
  setSecondsExhaustedCallbackContinue: (callback) => {
    set({ secondsExhaustedCallbackContinue: callback });
  },
  setNotEnoughSecondsModal(value) {
    set({ isNotEnoughSecondsModal: value });
  },
  isNotEnoughSecondsModal: false,
  isBasePlan: false,
  isChatAvailable: true,
  isEmbedAvailable: false,
  isInactivePlan: false,
  premiumVoicesAllowed: false,
  productName: '',
  seconds: 0,
  currentSubscription: null,
  setIsSecondsExhaustedModal: (value) => {
    set({
      isSecondsExhaustedModal: value
    });
  },
  updateCreditStore: (key, value) => {
    set({ [key]: value });
  },
  getSubscriptions: async (key) => {
    try {
      const data = await creditApi.getCurrentSubscriptions(key);
      if (data.length) {
        set({ currentSubscription: data[0] });
      }
      return data;
    } catch (error) {
      toast.error('Error fetching subscriptions. Please try again later.');
    }
  }
}));
